import { BaseAPI } from "@/api/baseAPI";
import type { Measure } from "@/types";

class MeasureAPI extends BaseAPI<Measure> {
  constructor() {
    super("measure");
  }
}

export default new MeasureAPI();
